import { IProfile } from "@assetmark/profile/dist/profileComponent";
import { GoalTypeEnum } from "../lib/das-api/model/goalTypeEnum";
import { LeadCategory } from "../models/lead-category-enum";
import { TLeadProfileResponse } from "../models/lead-profile-response";

export const parseGoalTypeEnum = (goal: string) => {
    if(goal.toLowerCase() === 'generalsavings') {
        return `3`;
    }
    if(goal.toLowerCase() === 'unknown') {
        return `1`;
    }
    if(goal.toLowerCase() === 'retirement') {
        return `2`;
    }
    return  '0';
};

export const convertLastPageToRedirectRoute = (lastPageVisited: string): string => {
    if(lastPageVisited.toLowerCase() === LeadCategory.ClientProfile.toLowerCase()) {
        return 'about';
    }
    if(lastPageVisited.toLowerCase() === LeadCategory.SetGoal.toLowerCase()) {
        return 'goals/retirement_age';
    }
    if(lastPageVisited.toLowerCase() === LeadCategory.RiskProfile.toLowerCase()) {
        return 'risk-profile';
    }
    return 'about';
};

export const parseProfileResposeToIProfile = (lead: TLeadProfileResponse): IProfile => {
    return {
        Investor: {
            FirstName: lead.firstName.getOrElse(''),
            LastName: lead.lastName.getOrElse(''),
            EmailAddress: lead.emailAddress.getOrElse(''),
            Age: lead.age.getOrElse(0),
        },
        investmentInfo: {
            InvestmentAmount: 0,
        },
        investmentReason: '0',
        page: 0,
    };
};